import React from "react";
import { ReactComponent as Android } from "../../assets/icons/Android.svg";
import { ReactComponent as IOS } from "../../assets/icons/IOS.svg";
import { ReactComponent as MobileApp } from "../../assets/images/MobileApp.svg";
import { ReactComponent as Bazaar } from "../../assets/icons/bazar.svg";
import { ReactComponent as Webapp } from "../../assets/icons/Group 1.svg";

const texts = {
  header: "دانلود اپلیکیشن کنتور",
  text:
    "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز ",
};

const btns = [
  {
    text: "دانلود از بازار",
    icon: <Bazaar />,
    link: "https://cafebazaar.ir/app/com.contor",
  },
  {
    text: "دانلود اپلیکیشن Android",
    icon: <Android />,
    link: "https://play.google.com/store/apps/details?id=com.contor",
  },
  {
    text: "دانلود از سیبچه",
    icon: <IOS />,
    link: "https://www.sibche.com/applications/contor",
  },
  {
    text: "وب اپلیکیشن",
    text2: "ویژه کاربران IOS",
    icon: <Webapp />,
    link: "https://app.myContor.ir",
  },
];

const DownloadBtn = ({ text, icon, link, text2 }) => {
  return (
    <div
      className="downloadBtn"
      onClick={() => link !== "" && window.open(link)}
    >
      {icon}
      <div style={{ display: "flex", flexDirection: "column" }}>
        <span>{text}</span>
        {text2 !== null && <span>{text2}</span>}
      </div>
    </div>
  );
};

const ApplicationDownload = ({ page }) => {
  return (
    <div
      className="appDownDiv"
      style={{ marginTop: page ? window.innerHeight * 0.12 : 0 }}
    >
      <MobileApp />
      <div>
        <span>{texts.header}</span>
        {page && (
          <span>{"استعلام رایگان و مدیریت هوشمند قبوض شرکت های خدماتی"}</span>
        )}
        {/* <span>{texts.text}</span> */}
        {btns.map((i, index) => {
          return (
            <DownloadBtn
              text={i.text}
              icon={i.icon}
              link={i.link}
              text2={i.text2 ? i.text2 : null}
              key={`#AppDonwload${index}`}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ApplicationDownload;
